<nav class="skip-links" aria-label="Skip navigation">
  @for (link of skipLinks; track link.href) {
    <a
      [href]="link.href"
      class="skip-link"
      (click)="focusElement($event, link.href)">
      {{ link.label }}
    </a>
  }
</nav>
